module.exports = __webpack_public_path__ + "img/logo_aurus.dcb496ae.svg";